export default __webpack_public_path__ + "static/logo-nav-ingeniosamente-f9c228315ceaaccda42753fe2a7a5182.png";